const AUTH_RETURN_TO_KEY = 'auth_return_to'

function currentReturnPath(): string {
  return `${window.location.pathname}${window.location.search}`
}

export function setAuthReturnTo(path: string): void {
  const trimmed = path.trim()
  if (!trimmed || !trimmed.startsWith('/')) return
  sessionStorage.setItem(AUTH_RETURN_TO_KEY, trimmed)
}

export function getAuthReturnTo(): string | null {
  const value = sessionStorage.getItem(AUTH_RETURN_TO_KEY)
  return value?.trim() || null
}

export function clearAuthReturnTo(): void {
  sessionStorage.removeItem(AUTH_RETURN_TO_KEY)
}

export function buildLoginUrl(returnTo?: string): string {
  const target = returnTo?.trim() || currentReturnPath()
  if (!target || target.startsWith('/login')) {
    return '/login'
  }
  return `/login?returnTo=${encodeURIComponent(target)}`
}

export function resolvePostAuthRedirect(options?: {
  returnToParam?: string | null
  stateFrom?: string | null
  fallback?: string
}): string {
  const stored = getAuthReturnTo()
  if (stored) {
    clearAuthReturnTo()
    return stored
  }

  const param = options?.returnToParam?.trim()
  if (param && param.startsWith('/')) {
    return param
  }

  const stateFrom = options?.stateFrom?.trim()
  if (stateFrom && stateFrom.startsWith('/')) {
    return stateFrom
  }

  return options?.fallback ?? '/profile'
}

export function redirectToLogin(returnTo?: string): void {
  window.location.href = buildLoginUrl(returnTo)
}
